<template>
  <div class="points-card-skeleton">
    <div class="skeleton-icon"></div>
    <div class="skeleton-points-body">
      <div class="skeleton-points-number"></div>
      <div class="skeleton-points-label"></div>
    </div>
    <div class="skeleton-convert-btn"></div>
  </div>
</template>

<script>
export default {
  name: "GiftPointsCardSkeleton"
}
</script>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-icon,
.skeleton-points-number,
.skeleton-points-label,
.skeleton-convert-btn {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.points-card-skeleton {
  background: #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem 1rem 1rem 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.skeleton-icon {
  position: absolute;
  top: -22px;
  left: 50%;
  transform: translateX(-50%);
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(90deg, #d1d5db 25%, #c4c8ce 50%, #d1d5db 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-points-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.skeleton-points-number {
  height: 24px;
  width: 120px;
}

.skeleton-points-label {
  height: 14px;
  width: 160px;
}

.skeleton-convert-btn {
  height: 36px;
  width: 140px;
  border-radius: 8px;
  margin-top: 4px;
}

@media (max-width: 1024px) {
  .points-card-skeleton {
    padding: 1.2rem 1rem 0.8rem 1rem;
    margin-top: 20px;
  }

  .skeleton-icon {
    top: -20px;
    width: 40px;
    height: 40px;
  }

  .skeleton-points-number {
    height: 20px;
    width: 100px;
  }

  .skeleton-points-label {
    height: 12px;
    width: 140px;
  }

  .skeleton-convert-btn {
    height: 32px;
    width: 120px;
  }
}

@media (max-width: 768px) {
  .points-card-skeleton {
    padding: 1rem 0.8rem 0.8rem 0.8rem;
    margin-top: 0;
  }

  .skeleton-icon {
    top: -18px;
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }

  .skeleton-points-number {
    height: 18px;
    width: 80px;
  }

  .skeleton-points-label {
    height: 10px;
    width: 100px;
  }

  .skeleton-convert-btn {
    height: 28px;
    width: 100%;
    margin-top: 6px;
  }
}

@media (max-width: 576px) {
  .points-card-skeleton {
    padding: 1rem 0.8rem 0.8rem 0.8rem;
    margin-top: 18px;
    border-radius: 10px;
  }

  .skeleton-icon {
    top: -16px;
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }

  .skeleton-points-number {
    height: 16px;
    width: 70px;
  }

  .skeleton-points-label {
    height: 10px;
    width: 90px;
  }

  .skeleton-convert-btn {
    height: 24px;
    width: 100px;
    border-radius: 6px;
  }
}

@media (max-width: 400px) {
  .points-card-skeleton {
    padding: 0.8rem 0.6rem 0.6rem 0.6rem;
    margin-top: 14px;
  }

  .skeleton-icon {
    top: -14px;
    width: 28px;
    height: 28px;
    border-radius: 6px;
  }

  .skeleton-points-number {
    height: 14px;
    width: 60px;
  }

  .skeleton-points-label {
    height: 8px;
    width: 80px;
  }

  .skeleton-convert-btn {
    height: 22px;
    width: 90px;
  }
}

@media (max-width: 576px) {
  .points-card-skeleton {
    min-width: 0;
    min-height: 120px;
    padding: 20px 16px 16px;
  }
}
</style>
